<div [formGroup]="form">
    <ion-row [formGroupName]="formGroupName" class="dateRangePicker">
        <ion-col size="6" size-sm="auto">
            <h6>{{ "components.form.dateRangePicker.startDate" | translate }}</h6>
            <ion-datetime-button datetime="startTime"></ion-datetime-button>

            <ion-modal [keepContentsMounted]="true">
                <ng-template>
                    <ion-datetime [formControlName]="startControlName" [max]="startDateMax" id="startTime"
                                  presentation="date" [locale]="ionLocale()"></ion-datetime>
                </ng-template>
            </ion-modal>
        </ion-col>
        <ion-col size="6" size-sm="auto">
            <h6>{{ "components.form.dateRangePicker.endDate" | translate }}</h6>
            <ion-datetime-button datetime="endTime"></ion-datetime-button>

            <ion-modal [keepContentsMounted]="true">
                <ng-template>
                    <ion-datetime [formControlName]="endControlName" [max]="endDateMax" [min]="endDateMin" id="endTime"
                                  presentation="date" [locale]="ionLocale()"></ion-datetime>
                </ng-template>
            </ion-modal>
        </ion-col>
    </ion-row>
</div>
